import React, { memo } from "react";
import {
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { isMobile } from "react-device-detect";
import "./index.css";

const PatrimonyMapMenuPositionsActionItem = ({
  disabled,
  icon,
  id,
  onClick,
  selected,
  title
}) => {
  return (
    <li>
      <OverlayTrigger
        placement="left"
        overlay={<Tooltip>{title}</Tooltip>}
        trigger={(disabled && disabled()) || isMobile ? null : ["hover", "focus"]}
      >
        <button
          className={`pmmpa-button ${selected && selected() ? "active" : ""} ${id}`}
          type="button"
          onClick={onClick}
          disabled={disabled && disabled()}
        >
          <div className="pmmpa-icon">{icon}</div>
          <div className="pmmpa-description">{title}</div>
        </button>
      </OverlayTrigger>
    </li>
  );
};

export default memo(PatrimonyMapMenuPositionsActionItem);
